<template>
    <div class="message">
        {{this.message}}
    </div>
</template>

<script>
export default {
    name:'message',
    data() {
        return {
           message:'hone'
        }
    },
}
</script>

<style lang="less" scoped>
   .message{
       width:100%;
       height: 500px;
       background-color: rgba(255, 228, 196, 0.356);
   }
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/message.vue